module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', {
    attrs: {
      "lastUpdated": _vm.lastUpdated
    }
  }, [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.hasWorldStore) ? _c('div', {
    staticClass: "navbar-filters"
  }, [(_vm.sellerAccountsList && _vm.sellerAccountsList.length > 0) ? _c('div', {
    ref: "saDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("S.Accounts: " + _vm._s(_vm.filterBySellAcc.length === 0 ? 'All' : _vm.filterBySellAcc.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterBySellAcc.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterBySellAcc.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.sellerAccountsList), function(sa) {
    return _c('div', {
      key: String(sa.sellerId),
      staticClass: "item",
      class: {
        selected: _vm.isSellerSelected(sa.sellerId)
      },
      attrs: {
        "data-value": sa.sellerId
      }
    }, [(_vm.isSellerSelected(sa.sellerId)) ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(sa.accountNickName) + "\n          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.filterUserCountries && _vm.filterUserCountries.length > 0) ? _c('div', {
    ref: "marketplaceDropdown",
    staticClass: "ui dropdown filter-dropdown navbar-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-trigger"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Marketplaces: " + _vm._s(_vm.filterByMarket.length === 0 ? 'All' : _vm.filterByMarket.length === 1 ? _vm.filterByMarket[0] : _vm.filterByMarket.length + ' selected'))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item",
    class: {
      selected: _vm.filterByMarket.length === 0
    },
    attrs: {
      "data-value": ""
    }
  }, [(_vm.filterByMarket.length === 0) ? _c('i', {
    staticClass: "check icon"
  }) : _vm._e(), _vm._v("\n            All\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._l((_vm.filteredCountries), function(c) {
    return _c('div', {
      key: c,
      class: [c === 's' ? 'divider' : 'item', {
        selected: _vm.filterByMarket.indexOf(c) >= 0 && c !== 's'
      }],
      attrs: {
        "data-value": c
      }
    }, [(_vm.filterByMarket.indexOf(c) >= 0 && c !== 's') ? _c('i', {
      staticClass: "check icon"
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('i', {
      class: c.toLowerCase().replace('uk', 'gb') + ' flag',
      staticStyle: {
        "margin-right": "8px"
      }
    }) : _vm._e(), _vm._v(" "), (c !== 's') ? _c('span', [_vm._v("Amazon." + _vm._s(_vm.getMarketplaceSuffix(c)))]) : _vm._e()])
  })], 2)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buybox-dashboard"
  }, [_c('div', {
    staticClass: "dashboard-content"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-state"
  }, [_c('i', {
    staticClass: "spinner loading icon"
  }), _vm._v(" "), _c('p', [_vm._v("Loading dashboard data...")])]) : (_vm.error) ? _c('div', {
    staticClass: "error-state"
  }, [_c('i', {
    staticClass: "exclamation triangle icon"
  }), _vm._v(" "), _c('h3', [_vm._v("Failed to load dashboard")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.fetchDashboardData
    }
  }, [_vm._v("Retry")])]) : [_c('div', {
    staticClass: "dashboard-stats"
  }, [(!_vm.onboardingComplete) ? _c('div', {
    staticClass: "stat-card ownership-card sk-skeleton-card"
  }, [_c('div', {
    staticClass: "stat-header"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("BUY BOX OWNERSHIP "), _c('i', {
    staticClass: "info circle icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-sm",
    staticStyle: {
      "width": "70%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-pill"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
    }
  })]), _vm._v("\n            Reading Buy Box status…\n          ")])]) : _c('BuyBoxOwnershipCard', {
    attrs: {
      "data": _vm.ownership
    }
  }), _vm._v(" "), (!_vm.onboardingComplete) ? _c('div', {
    staticClass: "stat-card revenue-card sk-skeleton-card"
  }, [_c('div', {
    staticClass: "stat-header revenue-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('span', {
    staticClass: "stat-title"
  }, [_vm._v("EST. DAILY REVENUE IMPACT "), _c('i', {
    staticClass: "info circle icon"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "stat-tag"
  }, [_vm._v("ESTIMATE")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-lg"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block sk-skel-sm",
    staticStyle: {
      "width": "85%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-block-wide"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-skel-pill"
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M23 4v6h-6"
    }
  }), _c('path', {
    attrs: {
      "d": "M1 20v-6h6"
    }
  }), _c('path', {
    attrs: {
      "d": "M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"
    }
  })]), _vm._v("\n            Awaiting Buy Box & sales data…\n          ")])]) : _c('RevenueImpactCard', {
    attrs: {
      "data": _vm.revenueImpact
    }
  })], 1), _vm._v(" "), (!_vm.onboardingComplete) ? _c('div', {
    staticClass: "sk-skeleton-section"
  }, [_c('div', {
    staticClass: "sk-section-label"
  }, [_vm._v("BUY BOX STATUS BREAKDOWN")]), _vm._v(" "), _c('div', {
    staticClass: "sk-status-grid"
  }, _vm._l((4), function(n) {
    return _c('div', {
      key: n,
      staticClass: "sk-status-placeholder"
    }, [_c('div', {
      staticClass: "sk-skel-block sk-skel-sm",
      staticStyle: {
        "width": "40%"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sk-skel-block sk-skel-xs",
      staticStyle: {
        "width": "60%"
      }
    })])
  }), 0)]) : _c('StatusBreakdown', {
    attrs: {
      "statusData": _vm.statusBreakdown,
      "activeType": _vm.activeStatusFilter
    },
    on: {
      "status-click": _vm.handleStatusFilter
    }
  }), _vm._v(" "), _c('PriorityIssuesList', {
    attrs: {
      "issues": _vm.onboardingComplete ? _vm.priorityIssues : [],
      "needActionCount": _vm.needActionCount,
      "totalIssues": _vm.totalIssues,
      "syncing": !_vm.onboardingComplete,
      "exporting": _vm.exporting
    },
    on: {
      "viewAll": _vm.viewAllAlerts,
      "export": _vm.exportPriorityIssuesCsv,
      "product-click": _vm.viewProductDetails,
      "action-click": _vm.viewProductDetails
    }
  })]], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44032bf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuyBoxDashboard.vue
// module id = 763
// module chunks = 2